export class TaboolaScriptsService {
  static getPixelCode(id: string) {
    return `
      window._tfa = window._tfa || [];
      !(function (t, f, a, x) {
        if (!document.getElementById(x)) {
          t.async = 1;
          t.src = a;
          t.id = x;
          f.parentNode.insertBefore(t, f);
        }
      })(
        document.createElement('script'),
        document.getElementsByTagName('script')[0],
        '//cdn.taboola.com/libtrc/unip/${id}/tfa.js',
        'tb_tfa_script',
      );
    `;
  }
}
